import { type FC } from "react";
import { useTranslation } from "react-i18next";
import OrganicDateRangePicker from "src/dashboards/organicMedia/components/Tabs/OrganicDateRangePicker";
import { SelectMenu } from "src/dashboards/salesProductAnalytics/components/salesProductShared";
import type { EngagementOverviewFilterState } from "../../hooks";

export interface EngagementFiltersBarProps {
  filters: EngagementOverviewFilterState;
  campaignOptions: Array<{ value: string; label: string }>;
  onRangeChange: (_range: { startDate: string; endDate: string }) => void;
  onCampaignChange: (_campaignId: string) => void;
  ariaLabel?: string;
}

const EngagementFiltersBar: FC<EngagementFiltersBarProps> = ({
  filters,
  campaignOptions,
  onRangeChange,
  onCampaignChange,
  ariaLabel,
}) => {
  const { t } = useTranslation();
  const resolvedAriaLabel = ariaLabel ?? t("engagementOverview.shared.filtersAriaLabel");

  return (
    <section className="engagement-overview-filters" aria-label={resolvedAriaLabel}>
      <div className="engagement-overview-filters__column">
        <div className="engagement-overview-filters__dates">
          <OrganicDateRangePicker
            startDate={filters?.startDate ?? ""}
            endDate={filters?.endDate ?? ""}
            onRangeChange={onRangeChange}
          />
        </div>
        <div className="engagement-overview-filters__campaign">
          <SelectMenu
            value={filters?.campaignId ?? "all"}
            options={campaignOptions ?? []}
            onChange={onCampaignChange}
            ariaLabel={t("engagementOverview.shared.campaignNameFilterAria")}
            className="engagement-overview-filters__select"
          />
        </div>
      </div>
    </section>
  );
};

export default EngagementFiltersBar;
